
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment_verifications/new",
      function () {
        return require("private-next-pages/payment_verifications/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment_verifications/new"])
      });
    }
  